import errorManager from '@/rollbar.js';

const isJson = (str) => {
  try {
    return JSON.parse(str);
  } catch (error) {
    console.error(error);
    return false;
  }
};

const remoteCodChecks = (json, options = {}) => {
  const { kind, path } = options;
  const json_param = JSON.stringify(json);
  Loader.show();
  $.ajax({
    url: path,
    data: {
      kind: kind,
      json: json_param,
    },
    cache: false,
    type: 'POST',
    success: function (response) {
      window.BuSchema.isValid = response.valid;
      let list = '<ul>';
      for (let er in response.errors) {
        list += `<li>${response.errors[er]}</li>`;
      }
      list += '</ul>';
      window.BuSchema.messages = list;
      updateResponse(json_param);
      Loader.hide();
      return response.valid;
    },
    error: function (xhr) {
      window.BuSchema.isValid = false;
      window.BuSchema.messages = `${xhr.status} ${xhr.statusText}`;
      updateResponse(json_param);
      console.error('Errore nella validazione del JSON');
      Loader.hide();
    },
  });
};

const validation = (json, options = false) => {
  let fields = {};
  let codDuplicates = [];
  let wrongFormat = [];
  let wrongTypes = [];
  let missingCodes = 0;
  let deepFields = [];
  let wrongFields = [];
  let wrongVariables = [];

  for (let field of json) {
    const { cod, type, values, subfields, injects, variable } = field;
    if (!cod) {
      missingCodes = missingCodes + 1;
    } else {
      if (!codWellFormed(field, options)) {
        wrongFormat = [...wrongFormat, cod];
        wrongFields = [...wrongFields, field];
      }
      if (!typeExist(field, options)) {
        wrongTypes = [...wrongTypes, type];
        wrongFields = [...wrongFields, field];
      }
      if (!validationVariable(field, options)) {
        wrongVariables = [...wrongVariables, variable];
        wrongFields = [...wrongFields, field];
      }
      if (fields[cod]) {
        codDuplicates = [...codDuplicates, cod];
        wrongFields = [...wrongFields, field];
      }
      fields[cod] = true;
    }

    if (values || injects || subfields) deepFields = [...deepFields, field];
  }

  window.BuSchema.isValid = showErrors({
    codDuplicates,
    wrongFormat,
    wrongTypes,
    missingCodes,
    wrongFields,
    wrongVariables,
  });

  if (!window.BuSchema.isValid) return false;

  if (!deepFields.length) return true;

  for (let field of deepFields) {
    goToDeepLevel(field);
  }
};

const validationVariable = (field) => {
  const { variable, type } = field;

  if (!variable) return true;

  if (!(variable instanceof Object || type != 'textarea')) return false;

  const { landing } = variable;
  const validVariable = /^\${.*?}$/;

  return validVariable.test(landing);
};

const goToDeepLevel = (field) => {
  const { type, values, injects, subfields } = field;

  if (!window.BuSchema.isValid) return false;

  if (type == 'radio' || type == 'checkbox') {
    validation(values, true);
  }
  if (injects) {
    validation(injects);
  }
  if (subfields) {
    validation(subfields);
  }
};

const showErrors = (errors) => {
  const { wrongFormat, codDuplicates, wrongTypes, missingCodes, wrongFields, wrongVariables } = errors;

  const validVariable = singleErrorType('formato errato per le variabili:', wrongVariables);
  const validWrong = singleErrorType('formato errato per i codici:', wrongFormat);
  const validDuplicate = singleErrorType('codici duplicati sullo stesso livello:', codDuplicates);
  const validWrongTypes = singleErrorType('queste tipologie non esistono:', wrongTypes);
  if (missingCodes > 0) {
    window.BuSchema.messages += `<p> mancano ${missingCodes} codici </p>`;
  }

  if (wrongFields.length) {
    wrongFields.forEach((wf) => {
      window.BuSchema.messages += `dettaglio fields errato ${JSON.stringify(wf)} <br> `;
    });
  }

  if (!validVariable || !validWrong || !validDuplicate || !validWrongTypes || missingCodes > 0) {
    return false;
  }
  return true;
};

const singleErrorType = (message, array) => {
  let codes = '';
  array.forEach((el) => (codes += `<b>${el}</b>,`));

  if (codes) {
    window.BuSchema.messages += `<p> <span>${message}</span> ${codes} </p>`;
    return false;
  }
  return true;
};

// only values of radio and checkbox could have a cod numbers
const codWellFormed = (field, options) => {
  const { cod, type } = field;

  if (options) {
    const isNumber = !isNaN(parseInt(cod));
    if (isNumber) return true;
  }

  const re = /^[A-Za-z]+[\w\-]*$/;

  return re.test(cod);
};

// values of radio ed checkbox don't need a type
const typeExist = (field, options) => {
  const { cod, type, subfields } = field;
  const types = [
    'free_text',
    'title',
    'checkbox',
    'radio',
    'number',
    'text',
    'multitext',
    'textarea',
    'datepicker',
    'remote',
    'sign_svg',
    'button',
  ];

  return options || subfields || types.find((current_type) => current_type == type);
};

const isValid = (myJsObj) => {
  const json = isJson(myJsObj);

  if (!json) {
    window.BuSchema.isValid = false;
    updateResponse();
    return null;
  }

  if ($('#labels').length) {
    window.BuSchema.isValid = true;
    return null;
  }

  if (!document.querySelector('#datein').value) {
    window.BuSchema.isValid = true;
    return null;
  }

  const dateStart = moment(document.querySelector('#datein').value, 'DD/MM/YYYY');
  const statValidationDate = $('*[data-start-json-validation]').data('startJsonValidation');
  const strictValidation = !dateStart.isBefore(moment(statValidationDate, 'DD/MM/YYYY'));
  let canUpdate = true;
  if (strictValidation) {
    const kindElement = $('#kind');
    const { remotekinds, path } = kindElement.data();
    const kind = kindElement.val();
    const remote = remotekinds.includes(kind);

    canUpdate = !remote;

    const checker = remote ? remoteCodChecks(json, { kind, path }) : validation(json);
    if (canUpdate) updateResponse(myJsObj);

    return checker;
  }

  window.BuSchema.isValid = true;

  if (canUpdate) updateResponse(myJsObj);

  return null;
};

const putJsonOnTextArea = (myJsObj) => {
  const str = JSON.stringify(JSON.parse(myJsObj), void 0, 4);
  document.querySelector('.json-area').value = str;
};

const validityHandler = () => {
  $(document).on('click', '#validator_btn', () => {
    let myJsObj = $('.json-area').val();

    window.BuSchema.messages = '';
    window.BuSchema.isValid = false;
    document.querySelector('.schema-form').classList.remove('success');
    document.querySelector('.schema-form').classList.remove('error');
    isValid(myJsObj);
  });
};

const updateResponse = (myJsObj = null) => {
  if (window.BuSchema.isValid) {
    $('.js-form-validate-submit-btn').prop('disabled', false);
    document.querySelector('.schema-form').classList.add('success');
    putJsonOnTextArea(myJsObj);
  } else {
    $('.js-form-validate-submit-btn').prop('disabled', true);
    document.querySelector('.schema-form').classList.add('error');
  }

  if (!$('#labels').length) {
    let bu_schema_errors = document.querySelector('.bu_schema_errors');

    if (bu_schema_errors) {
      bu_schema_errors.innerHTML = window.BuSchema.messages;
    }
  }
};

const editSetup = () => {
  if (!$('.schema-form').data().newComponent) {
    let myJsObj = $('.json-area').val();
    putJsonOnTextArea(myJsObj);
  }
};

const init = () => {
  try {
    validityHandler();
    editSetup();
  } catch (error) {
    errorManager(error);
  }
};

window.BuSchema = {
  init: init,
  messages: '',
  isValid: false,
};
